import { Link } from '@tanstack/react-router'
import type { CSSProperties, PointerEventHandler, ReactNode } from 'react'

import { stockLinkOptions } from '@/components/ui/symbol-link'

interface SymbolTargetProps {
  symbol: string
  /** The host's own way to open a stock (the chart workspace's tab); absent, the stock page. */
  onOpenSymbol?: ((symbol: string) => void) | undefined
  className?: string
  style?: CSSProperties
  'aria-label'?: string
  onPointerMove?: PointerEventHandler<HTMLElement>
  onFocus?: () => void
  children: ReactNode
}

/**
 * A chart card or heatmap tile that opens its stock: a real link to the stock page (middle click,
 * new tab, a copyable address), or a button handing the symbol to the host when it opens stocks
 * itself.
 */
export default function SymbolTarget({
  symbol,
  onOpenSymbol,
  children,
  ...rest
}: SymbolTargetProps) {
  if (onOpenSymbol === undefined) {
    return (
      <Link {...stockLinkOptions(symbol)} {...rest}>
        {children}
      </Link>
    )
  }
  return (
    <button
      type="button"
      {...rest}
      onClick={() => {
        onOpenSymbol(symbol)
      }}
    >
      {children}
    </button>
  )
}
